/* v2.87 · Motor-group feeder NEC 430.24 inputs — extracted from
   Calculators.jsx. Dynamic list of motor rows sharing a feeder. */
export function MotorGroupInputs({ form, patchForm }) {
  const updateRow = (idx, patch) => {
    const list = [...form.motor_group_motors];
    list[idx] = { ...list[idx], ...patch };
    patchForm({ motor_group_motors: list });
  };

  return (
    <div className="mt-4 p-3 border border-[#00E5FF]/20 bg-[#00E5FF]/5"
         data-testid="cond-motor-group-fields">
      <div className="flex items-center justify-between mb-2">
        <div className="label-tag">// motor group · NEC 430.24 feeder ampacity</div>
        <button type="button"
          onClick={() => patchForm({
            motor_group_motors: [...form.motor_group_motors,
              { tag: `M-${form.motor_group_motors.length + 1}`, hp: 5 }],
          })}
          className="text-[10px] font-mono text-[#00E5FF] hover:underline"
          data-testid="cond-mg-add">+ add motor</button>
      </div>
      <div className="space-y-2">
        {form.motor_group_motors.map((m, idx) => (
          <div key={idx} className="grid grid-cols-12 gap-2 items-center text-xs font-mono"
               data-testid={`cond-mg-row-${idx}`}>
            <input type="text" placeholder="tag" value={m.tag ?? ""}
              onChange={(e) => updateRow(idx, { tag: e.target.value })}
              className="col-span-2 bg-black/40 border border-white/10 px-2 py-1 focus:border-[#00E5FF] outline-none"
              data-testid={`cond-mg-tag-${idx}`} />
            <input type="number" placeholder="hp" value={m.hp ?? ""}
              onChange={(e) => updateRow(idx, {
                hp: e.target.value === "" ? "" : Number(e.target.value),
                fla: undefined,
              })}
              className="col-span-2 bg-black/40 border border-white/10 px-2 py-1 focus:border-[#00E5FF] outline-none"
              data-testid={`cond-mg-hp-${idx}`}
              title="Horsepower — resolved to FLC via NEC 430.250 at the feeder voltage. Leave blank to enter FLA directly."/>
            <input type="number" placeholder="or FLA" value={m.fla ?? ""}
              onChange={(e) => updateRow(idx, {
                fla: e.target.value === "" ? undefined : Number(e.target.value),
                hp: undefined,
              })}
              className="col-span-2 bg-black/40 border border-white/10 px-2 py-1 focus:border-[#00E5FF] outline-none"
              data-testid={`cond-mg-fla-${idx}`}
              title="Nameplate FLA — overrides hp lookup when supplied."/>
            <input type="number" placeholder={`V (${form.voltage})`} value={m.voltage ?? ""}
              onChange={(e) => updateRow(idx, {
                voltage: e.target.value === "" ? "" : Number(e.target.value),
              })}
              className="col-span-2 bg-black/40 border border-white/10 px-2 py-1 focus:border-[#00E5FF] outline-none"
              data-testid={`cond-mg-v-${idx}`}
              title="Motor terminal voltage — defaults to feeder voltage."/>
            <select value={m.phases ?? ""}
              onChange={(e) => updateRow(idx, {
                phases: e.target.value === "" ? "" : Number(e.target.value),
              })}
              className="col-span-2 bg-black/40 border border-white/10 px-2 py-1 focus:border-[#00E5FF] outline-none"
              data-testid={`cond-mg-ph-${idx}`}>
              <option value="">phase (auto)</option>
              <option value="0">DC</option>
              <option value="1">1φ AC</option>
              <option value="3">3φ AC</option>
            </select>
            <button type="button"
              onClick={() => {
                const list = form.motor_group_motors.filter((_, i) => i !== idx);
                patchForm({ motor_group_motors: list.length ? list : form.motor_group_motors });
              }}
              disabled={form.motor_group_motors.length <= 1}
              className="col-span-2 text-[#FF3B30] hover:underline disabled:opacity-30"
              data-testid={`cond-mg-remove-${idx}`}>✕ remove</button>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-2">
        <span className="text-xs text-gray-400">Other non-motor loads (A):</span>
        <input type="number" value={form.motor_group_other_loads_amps}
          onChange={(e) => patchForm({ motor_group_other_loads_amps: Number(e.target.value) })}
          className="w-24 bg-black/40 border border-white/10 px-2 py-1 text-xs font-mono focus:border-[#00E5FF] outline-none"
          data-testid="cond-mg-other-loads" />
        <span className="text-[10px] text-gray-500 font-mono">added at 100 % per NEC 430.24</span>
      </div>
    </div>
  );
}
